import React, { FC } from 'react';
import { AssignUnassignPriorityError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { AssignUnassignPriorityErrorProps } from './types';

const getErrorMessage = (error: AssignUnassignPriorityErrorProps['updatePriorityError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AssignUnassignPriorityError.INVALID_COMMODITY_ID:
      return <Trans>Invalid Commodity Id.</Trans>;
    case AssignUnassignPriorityError.ASSIGN_UNASSIGN_PRIORITY_ERRORED:
      return <Trans>Assign Unassign Priority Error.</Trans>;
    case AssignUnassignPriorityError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Required Permission Missing.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const AssignUnassignPriorityErrorModal: FC<AssignUnassignPriorityErrorProps> = ({
  updatePriorityError,
  close,
}) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Assign Unassign Priority Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updatePriorityError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
